define('commons/autocomplete',['jquery', 'commons/message-manager', 'parse-dms', 'async!google-maps'], function($, messages, parseDMS) {
    return function(locationSearchInput, map) {
        this.map = map;
        // Create autocomplete search field
        if (locationSearchInput) {
            // Autocomplete
            var geocoder = new google.maps.Geocoder;
            var autocomplete = new google.maps.places.Autocomplete($(locationSearchInput).get(0), {
                fields: ['place_id', 'name', 'types']
            });
            var marker = null;
            var errorMessage = "An error occurred, related to either the coordinates format or an invalid address. Please enter another address or set of coordinates.";

            autocomplete.bindTo('bounds', this.map);

            var displayPlaceId = function (address) {
                if (marker) {
                    marker.setMap(null);
                }
                geocoder.geocode({'address': address}, $.proxy(function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            if (results[0].geometry.viewport) {
                                map.fitBounds(results[0].geometry.viewport);
                            } else {
                                map.setCenter(results[0].geometry.location);
                                map.setZoom(17);
                            }
                            marker = new google.maps.Marker({
                                map: map,
                                title: results[0].formatted_address,
                                position: results[0].geometry.location
                            });
                            return;
                        }
                    }
                    messages.error(errorMessage);
                }, this));
            };

            var service = new google.maps.places.AutocompleteService();
            var useFirstPrediction = $.proxy(function(predictions, status) {
                if (status != google.maps.places.PlacesServiceStatus.OK) {
                    messages.error(errorMessage);
                    return;
                }
                predictions.some($.proxy(function(prediction) {
                    if (prediction.place_id) {
                        displayPlaceId(prediction.description);
                        return true;
                    }

                }, this));
            }, this);

            google.maps.event.addListener(autocomplete, 'place_changed', $.proxy(function() {

                var place = autocomplete.getPlace();

                if (place.place_id) {
                    // The user chose a place
                    displayPlaceId(autocomplete.getPlace().name);

                } else {
                    // Enter case
                    var raw = place.name;
                    try {
                        var parsed = parseDMS(raw);
                        var lat = parsed.lat;
                        var lng = parsed.lon;
                        if (lat && lng <= 180) {
                            if (marker) {
                                marker.setMap(null);
                            }
                            this.map.setCenter(new google.maps.LatLng(lat, lng));
                            this.map.setZoom(17);
                            marker = new google.maps.Marker({
                                map: map,
                                title: raw.trim(),
                                position: new google.maps.LatLng(lat, lng)
                            });
                            return;
                        }
                        service.getQueryPredictions({ input: raw }, useFirstPrediction);
                    }
                    catch(error) {
                        service.getQueryPredictions({ input: raw }, useFirstPrediction);
                    }

                }

            }, this));
        }
    };
});
